import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DELETE_COURSE_TYPE_MUTATION } from '../graphql/mutations'
import { DELETE_COURSE_TYPE } from '../redux/action-types'

const useDeleteCourseTypeMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.courseTypes.courseTypes,
  )

  const mutate = useCallback(
    async id => {
      await apolloService.mutate(
        DELETE_COURSE_TYPE_MUTATION,
        {
          id,
        },
        dispatch,
        DELETE_COURSE_TYPE,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useDeleteCourseTypeMutation
